import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext'; // Import Language Context

const Card = ({ id, title, description, imgSrc, imgAlt, linkText, linkPath }) => {
  const { language } = useLanguage();
  return (
    <div className="card border-primary rounded-lg shadow-md">
      {imgSrc && (
        <img src={imgSrc} alt={imgAlt} className="card-image rounded-t-lg" />
      )}
      <div className="card-content p-4">
        <h3 className="card-title text-lg font-semibold mb-2">{title}</h3>
        <p className="card-description text-sm text-gray-600" dangerouslySetInnerHTML={{ __html: description }}></p>
        <Link to={linkPath} className="card-link text-gray-700 hover:text-white-700" aria-label={`Lexo më shumë për ${title}`}>
          {language === 'Shqip' ? 'Shiko më shumë' : 'Show more'}
        </Link>
      </div>
    </div>
  );
};

export default Card;